import { Component, OnInit, OnDestroy, Inject, ViewChild, ElementRef } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EForm } from '../../../shared-components/e-forms/e-form.model';
import { Student } from '../../../shared-components/student/student.model';
import { EFormService } from '../../../shared-components/e-forms/e-form.service';
import { YearService } from '../../../shared-components/year/year.service';
import { ErrorList } from '../../../shared-components/controls/error-prompt/error-list.model';
import * as _ from 'lodash';
import { StudentService } from '../../../shared-components/student/student.service';
import { LoginService } from '../../../shared-modules/login/login.service';
import { Year } from '../../../shared-components/year/year.model';
import * as moment from 'moment';
import { UserService } from '../../../shared-components/user/user.service';


@AutoUnsubscribe({ includeArrays: true })
@Component({
    selector: 'app-e-form-select-year-dialog',
    templateUrl: './e-form-select-year-dialog.component.html',
    styleUrls: ['./e-form-select-year-dialog.component.css']
})
export class EFormSelectYearDialogComponent implements OnInit, OnDestroy {

    selectedForm: EForm;
    formStudents: Student[] = [];
    errors: ErrorList[] = [];
    subscriptions: Subscription[] = [];
    @ViewChild('refStudent', { read: ElementRef, static: true }) refStudent: ElementRef;

    // Years
    years: Year[] = [];
    selectedYear: Year;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private eFormService: EFormService,
        private yearService: YearService,
        private studentService: StudentService,
        private dialogRef: MatDialogRef<EFormSelectYearDialogComponent>,
        private loginService: LoginService,
        private userService: UserService
    ) {
        this.selectedForm = _.cloneDeep(data.Form);
    }

    ngOnInit() {
        if(this.loginService.LoginSettings.V10) {
            this.years = _.cloneDeep(this.studentService.enrollmentYears)
        }
        else {
            if (this.userService.currentUser.UserType == 1) {
                this.years = _.cloneDeep(this.yearService.yearsForC360);
            }
            else {
                this.years = _.cloneDeep(this.yearService.allYears.filter(o => o.SchoolID == this.yearService.student360Year.SchoolID));
            }
        }
        this.years = this.years.filter(year => moment(year.StartDate).isSameOrAfter(this.yearService.defaultYear.StartDate));
        this.selectedYear = _.cloneDeep(this.yearService.defaultYear);
    }

    ngOnDestroy() { }


    cancelClick() {
        this.dialogRef.close();
    }

    nextClick() {
        this.validate();
        if (this.errors.length == 0) {
            if (this.loginService.LoginSettings.V10) {
                this.selectedForm.AYIdentifier = this.selectedYear.AYIdentifier;
            }
            else {
                this.selectedForm.Year_ID = this.selectedYear.Id;
            }
            this.dialogRef.close(this.selectedForm);
        }
    }

    validate() {
        this.errors = [];
        // if (!this.selectedForm.Student_ID || this.selectedForm.Student_ID <= 0) {
        //     this.errors.push({
        //         fieldName: 'Student',
        //         fieldRef: this.refStudent,
        //         errorMsg: 'is required.'
        //     });
        // }
    }

}
